import React from "react";
import { Mail } from "lucide-react";
import { BlurFade } from "../BlurFade";

const EarlyAccess: React.FC = () => {
  return (
    <BlurFade delay={0.25} inView>
      <div className="w-full p-5 sm:p-7 lg:p-10 text-white">
        <div className="space-y-1 justify-center items-center text-xl sm:text-2xl font-semibold md:text-3xl  text-center lg:text-5xl xl:text-6xl">
          <h3>Stay in the loop to match</h3>
          <h3>your pace with New India</h3>
          <div className="w-full flex justify-center pt-1 items-center">
            <p className="text-[#8896AB] text-sm font-light sm:text-lg md:text-xl w-full max-w-xs sm:max-w-xl md:max-w-sm lg:max-w-3xl pt-2 xl:text-[1.9rem] xl:leading-none">
              Get exclusive insights, updates, and tips delivered right to your
              inbox.
            </p>
          </div>
        </div>
        <form className="w-full flex justify-center items-center my-5">
          <div className="flex flex-col sm:flex-row items-center gap-3 w-full justify-center">
            <div>
              <div className="relative w-full">
                <input
                  id="input-09"
                  className="peer rounded-md ps-9 text-xs w-48 lg:w-96 focus:ring-0 focus:outline py-2 lg:py-3 text-neutral-900 font-normal bg-white"
                  placeholder="Enter your work email"
                  type="email"
                />
                <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-white bg-white rounded-md peer-disabled:opacity-50">
                  <Mail
                    size={16}
                    strokeWidth={2}
                    aria-hidden="true"
                    className="text-neutral-700"
                  />
                </div>
              </div>
            </div>
            <button className="bg-[#22C55E]  hover:bg-opacity-90 transition-all duration-200 ease-out sm:max-w-[8rem] w-full px-3 lg:py-3 py-2 sm:py-2.5 max-w-48 rounded-md font-normal text-xs">
              Get early access
            </button>
          </div>
        </form>
        <div className="flex justify-center items-center">
          <p className="w-full max-w-xs md:max-w-sm lg:max-w-[45rem] lg:text-base xl:text-lg text-center font-normal text-[#8896AB] text-sm">
            Your privacy matters! We'll only use your data to send you the
            latest updates and never share it with anyone else.
          </p>
        </div>
      </div>
    </BlurFade>
  );
};

export default EarlyAccess;
